import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const _createFetchParams = (requesterId, search, pagination) => ({
    requester: requesterId,
    search,
    ...pagination
});

const
    name = 'serviceNowCompanies',
    exports = {
        createFetchParams: _createFetchParams,
        ...storeModuleFactory({
            name,
            timeout:  TIMEOUT_STORE.TIMEOUT_STORE_BIG,
            endpoint: endpoints.serviceNow.companiesEndpoint
        })
    };

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/serviceNowCompanies.js